import * as actionTypes from "../Actions/actionTypes";

const initialState = {
  notes: [],
  loading: false,
  error: null,
  success: false,
  updatedNote: null,
};

const ApplicationNotesReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_APPLICATION_NOTES_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case actionTypes.GET_APPLICATION_NOTES_SUCCESS:
      return {
        ...state,
        loading: false,
        notes: action.notes,
        error: null,
        success: true,
      };

    case actionTypes.GET_APPLICATION_NOTES_ERROR:
      return {
        ...state,
        loading: false,
        error: action.error,
        success: false,
      };

    case actionTypes.UPDATE_APPLICATION_NOTES_REVIEW_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        updatedNote: null,
      };

    case actionTypes.UPDATE_APPLICATION_NOTES_REVIEW_SUCCESS:
      return {
        ...state,
        loading: false,
        updatedNote: action.note,
        error: null,
        success: true,
        // Update the note in the notes array
        notes: state.notes.map((note) =>
          note.id === action.note.id ? { ...note, ...action.note } : note
        ),
      };

    case actionTypes.UPDATE_APPLICATION_NOTES_REVIEW_ERROR:
      return {
        ...state,
        loading: false,
        error: action.error,
        success: false,
      };

    case actionTypes.CLEAR_APPLICATION_NOTES_STATE:
      return initialState;

    default:
      return state;
  }
};

export default ApplicationNotesReducer;
